import React from "react"
import ChevronIcon from './ChevronIcon'
const ArrowRightIcon = ({ style }) => (
  <div
    style={{
      transform: 'rotate(90deg)'
    }}
  >
    <ChevronIcon style={style}/>
  </div>
)

export default ArrowRightIcon



// WEBPACK FOOTER //
// ./src/AtomicComponents/Icons/ArrowRightIcon.jsx